import { PAYMENTS_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';
import { ServiceTypes } from '@/types';

export const getMyServices = (): Promise<ServiceTypes[]> => {
  return axios.get(PAYMENTS_BACKEND_URL + 'my-services').then((response: any) => {
    return parseServices(response._embedded?.services as ServiceTypes[]);
  });
};
const SERVICES_DICTIONARY: any = {
  // Service name from backend API : service name
  MDirector: 'email_marketing',
  Landings: 'landing_optimizer',
  Transaccionales: 'email_transactional',
  Automation: 'marketing_automation',
  Payments: 'payments',
  Integrations: 'integrations',
};

const parseServices = (services: ServiceTypes[] | undefined): ServiceTypes[] => {
  if (services && services.length > 0) {
    const newServices: any[] = services
      .map(function (service: ServiceTypes) {
        const name = SERVICES_DICTIONARY[service.service];
        if (!name) {
          return null;
        }
        service.service = name;
        return service;
      })
      .filter(function (service: any) {
        return service;
      });
    return newServices;
  }
  return [];
};
